import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";
import MessageList from "../MessageView/MessageList";
import ConversationHeader from "./ConversationHeader";
import ChatComposer from "./ChatComposer";
import TypingIndicator from "./TypingIndicator";
import "./ConversationView.css";
import {
  chatCurrentUserIdState,
  selectedChatRoomNameState,
  selectedChatRoomState,
} from "../../state/chatState";
import { isGroupChatAdmin, isUserActiveInRoom } from "../../chatRoomUtils";

const ConversationView = () => {
    const selectedRoom = useRecoilValue(selectedChatRoomState);
    const displayName = useRecoilValue(selectedChatRoomNameState);
    const currentUserIdentifier = useRecoilValue(chatCurrentUserIdState);

    const canCompose = useMemo(
        () => isUserActiveInRoom(selectedRoom, currentUserIdentifier),
        [currentUserIdentifier, selectedRoom],
    );

    const isAdminOnlyGroup = useMemo(
        () => selectedRoom?.chatType === "group" && Boolean(selectedRoom?.adminOnly),
        [selectedRoom],
    );

    const canSendMessages = useMemo(
        () => canCompose && (!isAdminOnlyGroup || isGroupChatAdmin(selectedRoom, currentUserIdentifier)),
        [canCompose, currentUserIdentifier, isAdminOnlyGroup, selectedRoom],
    );

    if (!selectedRoom) {
        return (
            <div className="conversation-view conversation-view-empty-pane">
                <div className="conversation-view-empty-content">
                    <div className="conversation-view-empty-icon" aria-hidden>
                        💬
                    </div>
                    <h2>Welcome to Chat</h2>
                    <p>
                        Select a conversation from the list to start messaging, or wait for someone to send you a
                        message.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="conversation-view">
            <ConversationHeader displayName={displayName} selectedRoom={selectedRoom} />
            <div className="conversation-view-messages">
                <MessageList />
                <TypingIndicator />
            </div>
            {canSendMessages ? (
                <ChatComposer />
            ) : (
                <div
                    className="conversation-view-inactive-notice"
                    role="status"
                    aria-live="polite"
                >
                    <p>
                        {canCompose
                            ? "Only admins can send messages in this conversation."
                            : "You are no longer an active member of this conversation."}
                    </p>
                </div>
            )}
        </div>
    );
};

export default ConversationView;
